import React, { useEffect, useState } from 'react';
import { useWorldStore, CAR_SCALE_DEFAULT } from '../state/worldStore';
import { adminPanel, AdminClose } from './adminChrome';

// CarSizePanel — ?cars=edit knob for the town-scale car fit. The cars (hero
// Lowrider + route traffic) were authored at real meters; the town is placed at
// a reduced scale to match the small avatars, so cars scale down to fit. One
// global scalar, live-tunable + persisted (localStorage 'carscale'). Copy the
// tuned value into CAR_SCALE_DEFAULT (worldStore) to bake it. −/= keys also work.
const safe = (side, base) => `max(${base}px, env(safe-area-inset-${side}))`;

const panel = adminPanel({
  position: 'fixed', left: safe('left', 16), top: `calc(${safe('top', 16)} + 200px)`, zIndex: 40,
  width: 190, pointerEvents: 'auto', color: '#ffe9c4', font: '12.5px system-ui, sans-serif',
  background: 'rgba(16,10,6,0.82)', border: '1px solid rgba(255,178,94,0.4)', borderRadius: 12,
  padding: '12px 12px 14px', backdropFilter: 'blur(8px)', WebkitBackdropFilter: 'blur(8px)',
});
const btn = {
  pointerEvents: 'auto', background: 'rgba(255,178,94,0.14)', color: '#ffd27d',
  border: '1px solid rgba(255,178,94,0.4)', borderRadius: 8, padding: '9px 0', cursor: 'pointer',
  font: '600 15px system-ui', textAlign: 'center', userSelect: 'none', flex: 1,
};

export default function CarSizePanel() {
  const ON = useWorldStore((s) => s.adminTool) === 'cars';
  const carScale = useWorldStore((s) => s.carScale);
  const setCarScale = useWorldStore((s) => s.setCarScale);
  const [fine, setFine] = useState(false);
  const [copied, setCopied] = useState(false);

  // Keyboard −/= (fine with Shift) — the same feel as the placement editor.
  useEffect(() => {
    if (!ON) return undefined;
    const onKey = (e) => {
      if (e.key !== '-' && e.key !== '=' && e.key !== '+') return;
      e.preventDefault();
      const step = e.shiftKey ? 0.01 : 0.04;
      setCarScale(carScale + (e.key === '-' ? -step : step));
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [ON, carScale, setCarScale]);

  if (!ON) return null;
  const step = fine ? 0.01 : 0.04;
  const copy = () => {
    navigator.clipboard?.writeText(String(carScale))
      .then(() => { setCopied(true); setTimeout(() => setCopied(false), 1200); }).catch(() => {});
  };

  return (
    <div style={panel}>
      <AdminClose />
      <div style={{ fontSize: 10.5, letterSpacing: 1.3, textTransform: 'uppercase', opacity: 0.7, marginBottom: 8 }}>Car size</div>
      <div style={{ fontVariantNumeric: 'tabular-nums', fontSize: 22, fontWeight: 700, textAlign: 'center', marginBottom: 8 }}>
        {carScale.toFixed(3)}×
      </div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
        <button style={btn} onClick={() => setCarScale(carScale - step)}>− smaller</button>
        <button style={btn} onClick={() => setCarScale(carScale + step)}>bigger +</button>
      </div>
      <label style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '4px 0 10px', cursor: 'pointer', opacity: 0.9 }}>
        <input type="checkbox" checked={fine} onChange={(e) => setFine(e.target.checked)} />
        fine steps (0.01)
      </label>
      <div style={{ display: 'flex', gap: 6 }}>
        <button style={{ ...btn, fontSize: 12 }} onClick={() => setCarScale(CAR_SCALE_DEFAULT)}>reset</button>
        <button style={{ ...btn, fontSize: 12, background: copied ? '#9dff7d' : 'rgba(255,178,94,0.14)', color: copied ? '#0c2c06' : '#ffd27d' }} onClick={copy}>
          {copied ? '✓ copied' : 'copy value'}
        </button>
      </div>
      <div style={{ opacity: 0.55, fontSize: 10.5, marginTop: 8, lineHeight: 1.35 }}>
        Bake into CAR_SCALE_DEFAULT (worldStore.js) once it looks right.
      </div>
    </div>
  );
}
